<template>
  <div class="page-wrapper">
    <h2 class="text-center mb-4">
      Политика в отношении обработки персональных данных
    </h2>

    <div>
      <h4 class="text-center pa-4">1. Общие положения</h4>

      <p class="text-justify">
        Настоящая политика обработки персональных данных составлена в
        соответствии с требованиями Федерального закона от 27.07.2006. №152-ФЗ
        «О персональных данных» и определяет порядок обработки персональных
        данных и меры по обеспечению безопасности персональных данных ОАНО
        «Образовательный центр «Эврика» (далее – Оператор).
      </p>
      <p class="text-justify">
        Оператор ставит своей важнейшей целью и условием осуществления своей
        деятельности соблюдение прав и свобод человека и гражданина при
        обработке его персональных данных, в том числе защиты прав на
        неприкосновенность частной жизни, личную и семейную тайну.
      </p>
      <p class="text-justify">
        Настоящая политика Оператора в отношении обработки персональных данных
        (далее – Политика) применяется ко всей информации, которую Оператор
        может получить о посетителях веб-сайта
        <a href="https://school.eurekacenter.ru/" class="card-link"
          >https://school.eurekacenter.ru/</a
        >.
      </p>

      <h4 class="text-center pa-4">
        2. Основные понятия, используемые в Политике
      </h4>

      <p class="text-justify">
        Автоматизированная обработка персональных данных – обработка
        персональных данных с помощью средств вычислительной техники;
      </p>
      <p class="text-justify">
        Блокирование персональных данных – временное прекращение обработки
        персональных данных (за исключением случаев, если обработка необходима
        для уточнения персональных данных);
      </p>
      <p class="text-justify">
        Веб-сайт – совокупность графических и информационных материалов, а также
        программ для ЭВМ и баз данных, обеспечивающих их доступность в сети
        интернет по сетевому адресу
        <a href="https://school.eurekacenter.ru/" class="card-link"
          >https://school.eurekacenter.ru/</a
        >;
      </p>
      <p class="text-justify">
        Информационная система персональных данных — совокупность содержащихся в
        базах данных персональных данных, и обеспечивающих их обработку
        информационных технологий и технических средств;
      </p>
      <p class="text-justify">
        Обезличивание персональных данных — действия, в результате которых
        невозможно определить без использования дополнительной информации
        принадлежность персональных данных конкретному Пользователю или иному
        субъекту персональных данных;
      </p>
      <p class="text-justify">
        Обработка персональных данных – любое действие (операция) или
        совокупность действий (операций), совершаемых с использованием средств
        автоматизации или без использования таких средств с персональными
        данными, включая сбор, запись, систематизацию, накопление, хранение,
        уточнение (обновление, изменение), извлечение, использование, передачу
        (распространение, предоставление, доступ), обезличивание, блокирование,
        удаление, уничтожение персональных данных;
      </p>
      <p class="text-justify">
        Оператор – государственный орган, муниципальный орган, юридическое или
        физическое лицо, самостоятельно или совместно с другими лицами
        организующие и (или) осуществляющие обработку персональных данных, а
        также определяющие цели обработки персональных данных, состав
        персональных данных, подлежащих обработке, действия (операции),
        совершаемые с персональными данными;
      </p>
      <p class="text-justify">
        Персональные данные – любая информация, относящаяся прямо или косвенно к
        определенному или определяемому Пользователю веб-сайта
        <a href="https://school.eurekacenter.ru/" class="card-link"
          >https://school.eurekacenter.ru/</a
        >;
      </p>
      <p class="text-justify">
        Пользователь – любой посетитель веб-сайта, имеющий учётную запись
        <a href="https://school.eurekacenter.ru/" class="card-link"
          >https://school.eurekacenter.ru/</a
        >;
      </p>
      <p class="text-justify">
        Предоставление персональных данных – действия, направленные на раскрытие
        персональных данных определенному лицу или определенному кругу лиц;
      </p>
      <p class="text-justify">
        Распространение персональных данных – любые действия, направленные на
        раскрытие персональных данных неопределенному кругу лиц (передача
        персональных данных) или на ознакомление с персональными данными
        неограниченного круга лиц, в том числе обнародование персональных данных
        в средствах массовой информации, размещение в
        информационно-телекоммуникационных сетях или предоставление доступа к
        персональным данным каким-либо иным способом;
      </p>
      <p class="text-justify">
        Трансграничная передача персональных данных – передача персональных
        данных на территорию иностранного государства органу власти иностранного
        государства, иностранному физическому или иностранному юридическому
        лицу;
      </p>
      <p class="text-justify">
        Уничтожение персональных данных – любые действия, в результате которых
        персональные данные уничтожаются безвозвратно с невозможностью
        дальнейшего восстановления содержания персональных данных в
        информационной системе персональных данных и (или) результате которых
        уничтожаются материальные носители персональных данных.
      </p>

      <h4 class="text-center pa-4">
        3. Оператор может обрабатывать следующие персональные данные
        Пользователя
      </h4>

      <p class="text-justify">
        Фамилия, имя, отчество, электронный адрес, номера телефонов, снилс,
        текстовые данные о результатах образовательной деятельности
      </p>

      <p class="card-text">
        Также на сайте происходит сбор и обработка обезличенных данных о
        посетителях (в т.ч. файлов «cookie») с помощью сервисов
        интернет-статистики (Яндекс Метрика и Гугл Аналитика и других).
        Вышеперечисленные данные далее по тексту Политики объединены общим
        понятием Персональные данные.
      </p>

      <h4 class="text-center pa-4">4. Цели обработки персональных данных</h4>

      <p class="card-text">
        Цель обработки персональных данных Пользователя — информирование
        Пользователя посредством отправки электронных писем, предоставление
        доступа Пользователю к сервисам, информации и/или материалам,
        содержащимся на веб-сайте, Сбор данных и материалов необходимых для
        оказания услуг. Также Оператор имеет право направлять Пользователю
        уведомления о новых продуктах и услугах, специальных предложениях и
        различных событиях. Пользователь всегда может отказаться от получения
        информационных сообщений, направив Оператору письмо на адрес электронной
        почты
        <a class="card-link" href="mailto:admin@school.eurekacenter.ru"
          >admin@school.eurekacenter.ru</a
        >
        с пометкой «Отказ от уведомлений». Обезличенные данные Пользователей,
        собираемые с помощью сервисов интернет-статистики, служат для сбора
        информации о действиях Пользователей на сайте, улучшения качества сайта
        и его содержания.
      </p>

      <h4 class="text-center pa-4">
        5. Правовые основания обработки персональных данных
      </h4>
      <p class="card-text">
        Оператор обрабатывает персональные данные Пользователя только в случае
        их заполнения и/или отправки Пользователем самостоятельно через
        специальные формы, расположенные на сайте
        <a href="https://school.eurekacenter.ru/" class="card-link"
          >https://school.eurekacenter.ru/</a
        >. Заполняя соответствующие формы и/или отправляя свои персональные
        данные Оператору, Пользователь выражает свое согласие с данной
        Политикой. Оператор обрабатывает обезличенные данные о Пользователе в
        случае, если это разрешено в настройках браузера Пользователя (включено
        сохранение файлов «cookie» и использование технологии JavaScript).
      </p>

      <h4 class="text-center pa-4">
        6. Порядок сбора, хранения, передачи и других видов обработки
        персональных данных
      </h4>
      <p class="card-text">
        Безопасность персональных данных, которые обрабатываются Оператором,
        обеспечивается путем реализации правовых, организационных и технических
        мер, необходимых для выполнения в полном объеме требований действующего
        законодательства в области защиты персональных данных. Оператор
        обеспечивает сохранность персональных данных и принимает все возможные
        меры, исключающие доступ к персональным данным неуполномоченных лиц.
        Персональные данные Пользователя никогда, ни при каких условиях не будут
        переданы третьим лицам, за исключением случаев, связанных с исполнением
        действующего законодательства. В случае выявления неточностей в
        персональных данных, Пользователь может актуализировать их
        самостоятельно, путем направления Оператору уведомление на адрес
        электронной почты Оператора /conference@iokm.ru с пометкой «Актуализация
        персональных данных». Срок обработки персональных данных является
        неограниченным. Пользователь может в любой момент отозвать свое согласие
        на обработку персональных данных, направив Оператору уведомление
        посредством электронной почты на электронный адрес Оператора
        <a class="card-link" href="mailto:admin@school.eurekacenter.ru"
          >admin@school.eurekacenter.ru</a
        >
        с пометкой «Отзыв согласия на обработку персональных данных».
      </p>

      <h4 class="text-center pa-4">
        7. Трансграничная передача персональных данных
      </h4>

      <p class="card-text">
        Оператор до начала осуществления трансграничной передачи персональных
        данных обязан убедиться в том, что иностранным государством, на
        территорию которого предполагается осуществлять передачу персональных
        данных, обеспечивается надежная защита прав субъектов персональных
        данных. Трансграничная передача персональных данных на территории
        иностранных государств, не отвечающих вышеуказанным требованиям, может
        осуществляться только в случае наличия согласия в письменной форме
        субъекта персональных данных на трансграничную передачу его персональных
        данных и/или исполнения договора, стороной которого является субъект
        персональных данных.
      </p>

      <h4 class="text-center pa-4">8. Ответственность сторон</h4>

      <p class="card-text">
        Администрация Сайта, не исполнившая свои обязательства, несет
        ответственность за убытки, понесенные Пользователем в связи с
        неправомерным использованием персональных данных, в соответствии с
        законодательством Российской Федерации.
      </p>
      <p class="card-text">
        В случае утраты или разглашения конфиденциальной информации
        Администрация Сайта не несет ответственности, если данная
        конфиденциальная информация стала публичным достоянием до ее утраты или
        разглашения, была получена от третьей стороны до момента ее получения
        Администрацией Сайта, была разглашена с согласия Пользователя.
      </p>
      <h4 class="text-center pa-4">9. Разрешение споров</h4>
      <p class="card-text">
        До обращения в суд с иском по спорам, возникающим из отношений между
        Пользователем Сайта и Администрацией Сайта, обязательным является
        предъявление претензии (письменного предложения о добровольном
        урегулировании спора).
      </p>
      <p class="card-text">
        Получатель претензии в течение 10 (десяти) календарных дней со дня
        получения претензии письменно уведомляет заявителя претензии о
        результатах рассмотрения претензии.
      </p>
      <p class="card-text">
        При недостижении соглашения спор будет передан на рассмотрение в суд в
        соответствии с действующим законодательством Российской Федерации.
      </p>
      <p class="card-text">
        К настоящей Политике конфиденциальности и отношениям между Пользователем
        и Администрацией Сайта применяется действующее законодательство
        Российской Федерации.
      </p>

      <h4 class="text-center pa-4">8. Заключительные положения</h4>
      <p class="card-text">
        Пользователь может получить любые разъяснения по интересующим вопросам,
        касающимся обработки его персональных данных, обратившись к Оператору с
        помощью электронной почты
        <a class="card-link" href="mailto:admin@school.eurekacenter.ru"
          >admin@school.eurekacenter.ru</a
        >. В данном документе будут отражены любые изменения политики обработки
        персональных данных Оператором. Политика действует бессрочно до замены
        ее новой версией. Актуальная версия Политики в свободном доступе
        расположена в сети Интернет по адресу
        <a
          href="https://school.eurekacenter.ru/personal_data_politic"
          class="card-link"
          >https://school.eurekacenter.ru/personal_data_politic</a
        >.
      </p>
    </div>
  </div>
</template>
